import {
  type StoreExtensionContext,
  StoreExtensionProvider,
} from '@blocksuite/affine-ext-loader';
import {
  RichTableBlockSchemaExtension,
  RichTableCellBlockSchemaExtension,
  RichTableRowBlockSchemaExtension,
} from '@blocksuite/affine-model';

import { RichTableBlockAdapterExtensions } from './adapters/extension.js';

export class RichTableStoreExtension extends StoreExtensionProvider {
  override name = 'affine-rich-table-block';

  override setup(context: StoreExtensionContext) {
    super.setup(context);
    context.register(RichTableBlockSchemaExtension);
    context.register(RichTableRowBlockSchemaExtension);
    context.register(RichTableCellBlockSchemaExtension);
    context.register(RichTableBlockAdapterExtensions);
  }
}
